/**
 * Axios with retry for remote backend (ERR_CONNECTION_REFUSED).
 * When backend is at https://backend-barrista.theautochef.com, ~80% of requests
 * can fail with connection refused. Retries help recover without user action.
 */
import axios from "axios";
import axiosRetry from "axios-retry";

const isRetryableNetworkError = (error) => {
  if (!error) return false;
  const code = error.code || "";
  const msg = String(error.message || "");
  return (
    code === "ERR_NETWORK" ||
    code === "ECONNREFUSED" ||
    code === "ECONNRESET" ||
    msg.includes("Network Error") ||
    msg.includes("ERR_CONNECTION_REFUSED")
  );
};

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => Math.min(1000 * Math.pow(2, retryCount), 8000),
  retryCondition: (error) => {
    if (isRetryableNetworkError(error)) return true;
    return axiosRetry.isNetworkOrIdempotentRequestError(error);
  },
  shouldResetTimeout: true,
});

export default axios;
